export const siteName = "嘿咻嘿咻漫画资讯站";
export const siteUrl = "https://characterz2.github.io";

export interface NavItem {
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "剧情解析", path: "/plot" },
  { label: "角色设定", path: "/characters" },
  { label: "读者评价", path: "/reviews" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];